/**
 * author: Patrick Vyn Badiang
 * 
 * description:
 * simply is the divider whenever one is needed
 */
import { FooterDivider } from "../styles.tsx";

const Divider = (props) => {
    return <FooterDivider {...props} />;
}

export default Divider;